import { createFileRoute } from '@tanstack/react-router';
import { eggStaticData } from '../..';

export const Route = createFileRoute('/_private-routes/engagement/$id/influencer/facebook_page')({
  staticData: eggStaticData
});
